<div class="SLV2-main-wrapper">
    
    <!-- <div class="col-xl-2 col-md-3" *ngIf="selfLearnService.isFromLearn()">
        <app-sidebar-learn></app-sidebar-learn>    
    </div> -->

    <div class="SLV2-body-section">

        <div class="SLV2-section-wrap SLV2-page-header-area">
            <div class="SLV2-page-header-lft">
                <button (click)="navigateToPreviousPage()" class="SLV2-header-text-button">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                    <span>Back</span>
                </button>
            </div>
        </div>


        <div class="SLV2-section-wrap">
            <div class="row">
                <div class="col-12 SLV2-shorts-col" *ngFor="let shorts of playlists; let i = index">

                    <div class="SLV2-shorts-box">
                        <div class="SLV2-shorts-video-wrap">
                            <video id="my_video_{{i}}" width="480px" height="550px" loop
                                [src]='shorts?.videoURL'>
                                <!-- <source src="assets/img/self-learn-v2/shorts/shorts-01.mp4" type='video/mp4' /> 
                                <source src="assets/img/self-learn-v2/shorts/shorts-01.webm" type='video/webm' /> -->
                            </video>
                            <div class="SLV2-shorts-video-btn-overlay" #shortsActn (click)="playPause(i); shortsActn.classList.toggle('pause')">
                                <button class="SLV2-shorts-play-btn">
                                    <!-- <img src="selflearnv2-ui/assets/img/self-learn-v2/play-blue-bg-icon.svg" />
                                    <img src="selflearnv2-ui/assets/img/self-learn-v2/pause-blue-bg-icon.svg" class="pause" /> -->
                                </button>
                            </div>
                        </div>
                        <div class="SLV2-shorts-despription-overlay" #descriptionOpen>
                            <h4 class="SLV2-shorts-title">{{shorts.title}}</h4>
                            <div class="SLV2-shorts-more-description">
                                <h5 class="SLV2-shorts-description-hdng">More description</h5>
                                <p class="SLV2-shorts-more-para">{{shorts.description}}</p>
                            </div>
                            <div class="SLV2-shorts-views-row">
                                <div class="SLV2-shorts-view"><img src="selflearnv2-ui/assets/img/self-learn-v2/views-icon.svg" /><span>1.5K views</span></div>
                                <button class="SLV2-shorts-more-btn" (click)="descriptionOpen.classList.toggle('open')">
                                    <img src="selflearnv2-ui/assets/img/self-learn-v2/close-white-icon.svg" class="open" />
                                    <img src="selflearnv2-ui/assets/img/self-learn-v2/more-icon.svg"  />
                                     more description</button>
                            </div>
                        </div>
                        <!-- <div class="SLV2-shorts-user-actn-section">
                            <button class="SLV2-user-btn like-btn">
                                <div class="SLV2-btn-icon" [ngClass]="{'active':userLikeStatus}" (click)="userLike()">
                                    <img src="assets/img/self-learn-v2/like-icon.svg" />
                                    <img src="assets/img/self-learn-v2/like-fill-icon.svg" class="color" />
                                </div>
                                <span>Like</span>
                            </button>
                            <button class="SLV2-user-btn dislike-btn">
                                <div class="SLV2-btn-icon" [ngClass]="{'active':userDislikeStatus}" (click)="userDislike()">
                                    <img src="assets/img/self-learn-v2/dislike-icon.svg" />
                                    <img src="assets/img/self-learn-v2/dislike-fill-icon.svg" class="color" />
                                </div>
                                <span>Dislike</span>
                            </button>
                            <button class="SLV2-user-btn share-btn">
                                <div class="SLV2-btn-icon">
                                    <img src="assets/img/self-learn-v2/share-icon.svg" />
                                </div>
                                <span>Share</span>
                            </button>
                            <button class="SLV2-user-btn report-btn">
                                <div class="SLV2-btn-icon" (click)="openErrorDialog()">
                                    <img src="assets/img/self-learn-v2/flag-icon.svg" />
                                </div>
                                <span>Report</span>
                            </button>
                        </div> -->
                    </div>
   
                </div>
            </div>
        </div>


    </div>
</div>